import { Typography, Stack } from "@mui/material";

const gold = "#fabe06";
const black = "#101207";

const DayHours = ({ day, hours, highlighted }) => {
  return (
    <Stack
      padding="5px"
      color={highlighted && gold}
      bgcolor={highlighted && black}
      direction="row"
      spacing={6}
      justifyContent="space-between"
    >
      <Typography fontFamily="Goblin One">{day}</Typography>
      <Typography fontFamily="Goblin One">{hours}</Typography>
    </Stack>
  );
};

export default DayHours;
